/**
 * WCAG AA 2.1 Accessibility Fixes
 * Companion to wcag-a11y.css
 */
(function() {
  'use strict';

  // Slick slider: focusable elements inside aria-hidden slides must not receive focus.
  // Slick sets aria-hidden="true" on off-screen slides but doesn't remove tabindex,
  // so keyboard users can tab into invisible content (axe rule: aria-hidden-focus).
  function fixSlickFocus(slider) {
    slider.find('.slick-slide[aria-hidden="true"]')
      .find('a, button, input, select, textarea, [tabindex]')
      .attr('tabindex', '-1');

    slider.find('.slick-slide:not([aria-hidden="true"])')
      .find('a[tabindex="-1"], button[tabindex="-1"], input[tabindex="-1"], select[tabindex="-1"], textarea[tabindex="-1"]')
      .removeAttr('tabindex');
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (typeof jQuery === 'undefined') return;

    // Slick: apply on init and after every slide change
    jQuery(document).on('init afterChange', '.slick-slider', function() {
      fixSlickFocus(jQuery(this));
    });

    // Catch sliders already initialized before this script ran
    jQuery('.slick-initialized').each(function() {
      fixSlickFocus(jQuery(this));
    });

    // aria-expanded: keep toggle buttons in sync with their dropdown state.
    // The theme adds/removes an 'active' class on the parent .tt-dropdown-obj
    // when a dropdown opens/closes. We mirror that state to aria-expanded.
    var dropdownToggles = document.querySelectorAll('.tt-dropdown-obj .tt-dropdown-toggle[aria-expanded]');

    function syncExpanded(toggle) {
      var obj = toggle.closest('.tt-dropdown-obj');
      if (!obj) return;
      toggle.setAttribute('aria-expanded', obj.classList.contains('active') ? 'true' : 'false');
    }

    // Initial state
    dropdownToggles.forEach(syncExpanded);

    // Watch for class changes on .tt-dropdown-obj via MutationObserver
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var obj = mutation.target;
          var toggle = obj.querySelector('.tt-dropdown-toggle[aria-expanded]');
          if (toggle) syncExpanded(toggle);
        }
      });
    });

    document.querySelectorAll('.tt-dropdown-obj').forEach(function(obj) {
      observer.observe(obj, { attributes: true });
    });
  });

})();
